import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Divider, TextField, MenuItem, SelectField, RaisedButton,
  Card, CardText, Drawer, Dialog, FlatButton, CircularProgress,
} from "material-ui";
import Add from "material-ui/svg-icons/content/add-circle";
import Getapp from "material-ui/svg-icons/action/get-app";
import {
  BuscarPrestaciones, NuevaPrestacion, Loading, LoadingExcel, obtenerTiposAtencion,
  CambiarTipoAtencion, BuscarBorradorSolicitud, deleteBorrador, OpenCargarBorrador,
  SetSolicitudesEnCurso, GetSolicitudesExcel, ContarRegistros,
} from "./actions";
import {
  ObtenerCentrosAtencion, ObtenerTiposArancel, ObtenerTiposPrestacion,
  CambiarTipoArancel, CambiarCentroAtencion, CambiarTipoPrestacion,
  CambiarCodFonasa, ObtenerUsuariosPerfil, CambiarCodPrestacion, ObtenerDatosUsuario,
} from "../../Global/actions";
import GrillaBusqueda from "../GrillaBusqueda/view";
import GrillaSolicitud from "../GrillaSolicitud/view";
import NuevaPrestacionForm from "../NuevaPrestacionForm/view";
import ErrorSnack from "../../ErrorSnack/view";
import { AddPrestacionSolicitud, UpdateIdSolicitud } from "../GrillaSolicitud/actions";
import guid from "../../../helpers/guid";
import styles from "../../styles/styles";
import apiConfig from "./../../../config/api";
import { ObtenerTiposArancelAll } from "../NuevaPrestacionForm/actions";
// import DialogAlert from "../../../componentsGlobal/DialogAlert";

class FiltroBusqueda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cambiosSinGuardar: false,
    };
  }
  componentWillMount() {
    window.removeEventListener("beforeunload", this.onUnload.bind(this));
    this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosContraloria}`, 1));
    this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosConvenios}`, 2));
    this.props.dispatch(ObtenerCentrosAtencion());
    this.props.dispatch(obtenerTiposAtencion());
    if (!this.props.ENV.DESHABILITAR_BORRADOR) {
      this.props.dispatch(BuscarBorradorSolicitud());
    }
    this.props.dispatch(ObtenerDatosUsuario());
    this.props.dispatch(ObtenerTiposArancelAll());
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onUnload.bind(this));
  }


  onUnload(event) { // the method that will be used for both add and remove event
    if (this.state.cambiosSinGuardar) {
      event.returnValue = true;
    }
  }

  CambiosSinGuardar = (cambios) => {
    this.setState({ cambiosSinGuardar: cambios });
  }

  ExportarExcel = () => {
    this.props.dispatch(LoadingExcel(true));
    this.props.dispatch(GetSolicitudesExcel());
  }

  CambiarTipoArancel = (event, index, value) => {
    this.props.dispatch(CambiarTipoArancel(value));
  }

  CambiarCentroAtencion = (event, index, value) => {
    this.props.dispatch(CambiarCentroAtencion(value));
    this.props.dispatch(ObtenerTiposPrestacion(value));
    this.props.dispatch(ObtenerTiposArancel(value));
  }

  CambiarTipoPrestacion = (event, index, value) => {
    this.props.dispatch(CambiarTipoPrestacion(value));
  }

  CambiarCodFonasa = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarCodFonasa(event.target.value));
    }
  }

  CambiarCodPrestacion = (event) => {
    this.props.dispatch(CambiarCodPrestacion(event.target.value));
  }

  CambiarTipoAtencion = (event, index, value) => {
    this.props.dispatch(CambiarTipoAtencion(value));
  }

  BuscarPrestaciones = (event, index, value) => {
    this.props.dispatch(Loading(true));
    this.props.dispatch(BuscarPrestaciones(value));
  }

  NuevaPrestacion = () => {
    this.props.dispatch(NuevaPrestacion());
  }

  CloseSetSolicitudesEnCurso = () => {
    this.props.dispatch(SetSolicitudesEnCurso(false));
  }

  CargarDetalleSolicitud = () => {
    // this.props.dispatch(GetDetalleSolicitud(this.props.idSolicitud));

    this.props.prestacionesSolicitud.forEach((element) => {
      // Por haber incongruencia en los datos, cuando se carga de base de datos, se setea local
      // La fecha viene en formato zulu porque en base de datos se guarda solo la fecha, sin la hora, cuando regresa, el locate lo pasa a menos 3 horas, visualmente se resta u dia
      // por eso se realiza la tranformacion local, para que pase a gmt
      let FechaInicioVigenciaPosterior = null;
      if (element.FechaInicioVigenciaPosterior) {
        const anho = Number(element.FechaInicioVigenciaPosterior.substring(0, 4));
        const mes = Number(element.FechaInicioVigenciaPosterior.substring(5, 7)) - 1;
        const dia = Number(element.FechaInicioVigenciaPosterior.substring(8, 10));
        FechaInicioVigenciaPosterior = new Date(anho, mes, dia);
      }
      let FechaTerminoVigenciaPosterior = null;
      if (element.FechaTerminoVigenciaPosterior) {
        const anho = Number(element.FechaTerminoVigenciaPosterior.substring(0, 4));
        const mes = Number(element.FechaTerminoVigenciaPosterior.substring(5, 7)) - 1;
        const dia = Number(element.FechaTerminoVigenciaPosterior.substring(8, 10));
        FechaTerminoVigenciaPosterior = new Date(anho, mes, dia);
      }
      // el codigo de operacion, viene en numero, pero en la web se usa como strig, con validacione varias
      const IdTipoAccionPrestacion = element.IdTipoAccionPrestacion ? element.IdTipoAccionPrestacion.toString() : "";

      //console.log("PRESTACION:", element);

      const prest = {
        COD_PRESTADOR: element.CodigoPrestacionPrestador,
        GLOSA_CODPRESTADOR: element.GlosaPrestacionPrestador,
        COD_ISAPRE: element.CodigoPrestacionIsapre,
        PROF_CCOD: element.CodigoProfesionalIsapre,
        VALOR: element.ValorPosterior,
        UNIDAD: element.UnidadPosterior,
        TIPO_ATENCION: element.TipoAtencion,
        // INICIO_VIG: element.IdTipoAccionPrestacion === 2 ? FechaTerminoVigenciaPosterior : FechaInicioVigenciaPosterior,
        INICIO_VIG: FechaInicioVigenciaPosterior,
        FECHA_FIN_VIG: FechaTerminoVigenciaPosterior,
        TIPO_PRESTACION: "",
        GUARISMO: element.GuarismoDP,
        PERTENENCIA_FONASA: element.PertenenciaFonasa,
        CODIGO_FONASA: element.CodigoFonasa,
        ITEM_IMED: element.ItemImedNumber,
        CENTRO_AT: element.CentroAtencion,
        SECUENCIA: element.CentroAtencionSecuencia,
        ARANCEL: element.GlosaArancel,
        RUTARANCEL: element.Arancel,
        IDPRESTACION: element.IdPrestacionIsapre,
        IDDETALLEPRESTACION: element.IdDetallePrestacionSolicitud,
        OPERACION: element.TipoAccionPrestacion,
        COD_OPERACION: IdTipoAccionPrestacion,
        GUID: guid.new(),
      };
      this.props.dispatch(AddPrestacionSolicitud(prest));
    });

    this.props.dispatch(UpdateIdSolicitud(this.props.idSolicitud, true));
    this.ocultarModalBorrador();
  }

  eliminarBorrador = () => {
    this.props.dispatch(deleteBorrador(this.props.idSolicitud, this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre));
    this.ocultarModalBorrador();
  }

  mostrarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(true));
  }

  ocultarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(false));
  }


  render() {
    const menuListTipoArancel = [];
    if (this.props.tiposArancel) {
      this.props.tiposArancel.forEach((element) => {
        menuListTipoArancel.push(<MenuItem key={element.Rut} value={element.Rut} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListCentroAtencion = [];
    if (this.props.centrosAtencion) {
      this.props.centrosAtencion.forEach((element) => {
        menuListCentroAtencion.push(<MenuItem key={element.Secuencia} value={element.Secuencia} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListTipoPrestaciones = [];
    if (this.props.tiposPrestaciones) {
      this.props.tiposPrestaciones.forEach((element) => {
        if (element.Id > 0) {
          menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={`${element.TipoAtencion}: ${element.Descripcion}`} style={styles.customWidthItem} />);
        } else {
          menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={element.Descripcion} style={styles.customWidthItem} />);
        }
      });
    }

    const menuListTipoAtencion = [];
    menuListTipoAtencion.push(<MenuItem key="0" value="0" primaryText="Todas" style={styles.customWidthItem} />);
    if (this.props.tiposAtencion) {
      this.props.tiposAtencion.forEach((element) => {
        menuListTipoAtencion.push(<MenuItem key={element.Simbolo} value={element.Simbolo} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const actionsModalCargarBorrador = [
      <FlatButton
        label="Eliminar"
        secondary
        onClick={this.eliminarBorrador}
      />,
      <FlatButton
        label="Continuar"
        secondary
        onClick={this.CargarDetalleSolicitud}
      />,
    ];

    return (
      <div>
        {this.props.token ?

          <div >
            <div style={styles.frameContenidoGeneral}>
              <Card zDepth={0} style={{ paddingBottom: 0 }}>
                <CardText style={{ paddingBottom: 0 }}>
                  <div className="row" style={{ paddingBottom: 0 }}>
                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h1}>Solicitud de Actualización de Arancel
                      </div>
                      <div style={styles.h2}>
                        Seleccione el centro de atención y tipo de arancel que desea consultar.
                        Además, si desea buscar una prestación en particular, puede adicionar a la búsqueda
                        el filtro por código del prestador o fonasa.
                      </div>
                      <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                      </div>
                    </div>
                  </div>
                  {
                    this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                      this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                      this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                      this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                      <div>
                        <div className="row">
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Centro de Atención </div>
                            {
                              this.props.centrosAtencion && this.props.centrosAtencion.length > 0 ?
                                <SelectField
                                  name="dd_fb_centroAtencion"
                                  id="dd_fb_centroAtencion"
                                  value={this.props.filtros.centroAtencion}
                                  onChange={this.CambiarCentroAtencion}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListCentroAtencion}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Tipo de Prestación </div>
                            {
                              this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 ?
                                <SelectField
                                  name="dd_fb_tipoPrestacion"
                                  id="dd_fb_tipoPrestacion"
                                  value={this.props.filtros.tipoPrestacion}
                                  onChange={this.CambiarTipoPrestacion}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListTipoPrestaciones}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect}> Tipo de Arancel </div>
                            {
                              this.props.tiposArancel && this.props.tiposArancel.length > 0 ?
                                <SelectField
                                  name="dd_fb_tipoArancel"
                                  id="dd_fb_tipoArancel"
                                  value={this.props.filtros.tipoArancel}
                                  onChange={this.CambiarTipoArancel}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListTipoArancel}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}>Tipo de Atención</div>
                            {
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                                <SelectField
                                  name="dd_fb_tipoAtencion"
                                  id="dd_fb_tipoAtencion"
                                  value={this.props.filtros.tipoAtencion}
                                  onChange={this.CambiarTipoAtencion}
                                  labelStyle={styles.h4}
                                  underlineStyle={styles.underlineSelectField}
                                  style={styles.selectFiledStyle}
                                  iconStyle={styles.iconSelectField}
                                  menuItemStyle={styles.menuItemStyleSelectField}
                                  selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                >
                                  {menuListTipoAtencion}
                                </SelectField>
                                :
                                <CircularProgress />
                            }
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}> Código del Prestador </div>
                            <TextField
                              name="txt_fb_codprestacion"
                              id="txt_fb_codprestacion"
                              value={this.props.filtros.codPrestacion || ""}
                              onChange={this.CambiarCodPrestacion}
                              maxLength={15}
                              underlineStyle={styles.underlineSelectField}
                              inputStyle={styles.h4}
                              style={styles.selectFiledStyle}
                            />
                          </div>
                          <div className="col-4" style={styles.colSelectFieldActualizar}>
                            <div style={styles.floatingClaseSelect2}> Código Isapre/Fonasa </div>
                            <TextField
                              name="txt_fb_codfonasa"
                              id="txt_fb_codfonasa"
                              value={this.props.filtros.codFonasa || ""}
                              onChange={this.CambiarCodFonasa}
                              errorText=""
                              maxLength={50}
                              underlineStyle={styles.underlineSelectField}
                              inputStyle={styles.h4}
                              style={styles.selectFiledStyle}
                            />
                          </div>
                        </div>
                      </div>
                      :
                      <CircularProgress
                        style={{
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                          padding: "50px 50px 100px 50px",
                        }}
                      />
                  }
                  <div className="row" style={{ paddingRight: 25 }}>
                    <div className="col-12" style={styles.colBotonesActualizar}>
                      {
                        !this.props.loadingExcel ?
                          <RaisedButton
                            onClick={this.ExportarExcel}
                            label="Exportar a Excel"
                            backgroundColor="#fff"
                            labelPosition="before"
                            overlayStyle={{ borderRadius: 5 }}
                            labelStyle={{
                              fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5, top: "-3px",
                            }}
                            style={{ width: "190px", borderRadius: 5 }}
                            buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                            icon={<Getapp />}
                            disabled={
                              !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                                this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                                this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                                this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                            }
                          />
                          :
                          <CircularProgress />
                      }
                      <RaisedButton
                        onClick={this.NuevaPrestacion}
                        label="Agregar Nueva"
                        backgroundColor="#fff"
                        labelPosition="before"
                        overlayStyle={{ borderRadius: 5 }}
                        labelStyle={{
                          fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5, top: "-3px",
                        }}
                        style={{ width: "160px", borderRadius: 5, marginLeft: 20 }}
                        buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                        icon={<Add style={{ verticalAlign: "sub" }} />}
                      />
                      {!this.props.loading ?
                        <RaisedButton
                          label="Buscar"
                          onClick={this.BuscarPrestaciones}
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                          disabled={
                            !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                              this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                              this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                          }
                        />
                        :
                        <RaisedButton
                          label="Cargando ..."
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                        />
                      }
                    </div>

                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h3}>Email de contacto</div>
                      <div style={styles.h2}>
                        Las notificaciones se realizarán a la siguiente dirección de correo electrónico:&nbsp;<strong>{this.props.datosUsuario.mail}</strong><br />
                        Si desea modificar el email de contacto, debe cambiarlo en la sección &quot;Datos del Prestador&quot;
                      </div>
                    </div>

                  </div>
                </CardText>
              </Card>
            </div>
            <div className="row" style={{ padding: 10, margin: "15px 0px 0px 0px" }} >
              <div className="col-12">
                <Divider />
              </div>
            </div>

            <GrillaBusqueda CambiosSinGuardar={this.CambiosSinGuardar} />

            <div className="row" style={{ padding: 10, margin: "15px 0px 0px 0px" }}>
              <div className="col-12">
                <Divider />
              </div>
            </div>

            <GrillaSolicitud CambiosSinGuardar={this.CambiosSinGuardar} />

            <Drawer
              width="100%"
              openSecondary
              open={this.props.modalNuevaPrestacion}
              docked={false}

            >
              {(this.props.modalNuevaPrestacion) ?
                <NuevaPrestacionForm CambiosSinGuardar={this.CambiosSinGuardar} />
                : null}
            </Drawer>

            <Dialog
              key="modalCargarBorrador"
              actions={actionsModalCargarBorrador}
              modal
              open={this.props.modalCargarBorrador}
              style={{ width: "100%", fontSize: "13px" }}
            >
              Usted tiene una solicitud incompleta ¿desea continuar la lista o eliminarla?
            </Dialog>

            <ErrorSnack />

            {this.props.solicitudEnCurso ?
              <Dialog
                key="modalSolicitudencurso"
                actions={[
                  <FlatButton
                    label="Aceptar"
                    secondary
                    onClick={this.CloseSetSolicitudesEnCurso}
                  />]}
                modal
                open={this.props.solicitudEnCurso}
                style={{ width: "100%", fontSize: "13px" }}
              >
                <p>Usted tiene una solicitud en curso con prestaciones aún pendientes.</p>
                <p>Debe esperar a que la solicitud esté resuelta, para enviar una nueva solicitud.</p>
              </Dialog> : null}
          </div>

          :
          null}
      </div>
    );
  }
}

FiltroBusqueda.defaultProps = {
  idSolicitud: null,
  loading: null,
  loadingExcel: null,
};

FiltroBusqueda.propTypes = {
  loadingExcel: PropTypes.bool,
  loading: PropTypes.bool,
  rutInstitucion: PropTypes.number.isRequired,
  rutPrestador: PropTypes.number.isRequired,
  isapre: PropTypes.string.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  tiposAtencion: PropTypes.array.isRequired,
  modalNuevaPrestacion: PropTypes.bool.isRequired,
  modalCargarBorrador: PropTypes.bool.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  idSolicitud: PropTypes.number,
  solicitudEnCurso: PropTypes.bool.isRequired,
  filtros: PropTypes.any.isRequired,
  datosUsuario: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  ENV: PropTypes.any.isRequired,
  token: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  pageSize: state.filtroBusqueda.pageSize,
  totalPaginas: state.filtroBusqueda.totalPaginas,
  loadingExcel: state.filtroBusqueda.loadingExcel,
  loading: state.filtroBusqueda.loading,
  rutPrestador: state.global.rutPrestador,
  isapre: state.global.isapre,
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.filtros_CAT.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.filtros_CAT.tiposPrestaciones,
  tiposAtencion: state.filtroBusqueda.tiposAtencion,
  modalNuevaPrestacion: state.filtroBusqueda.modalNuevaPrestacion,
  modalCargarBorrador: state.filtroBusqueda.modalCargarBorrador,
  prestacionesSolicitud: state.filtroBusqueda.prestacionesSolicitud,
  idSolicitud: state.filtroBusqueda.idSolicitud,
  solicitudEnCurso: state.filtroBusqueda.solicitudEnCurso,
  token: state.global.token,
  filtros: {
    tipoArancel: state.global.filtros_CAT.tipoArancel,
    centroAtencion: state.global.filtros_CAT.centroAtencion,
    tipoPrestacion: state.global.filtros_CAT.tipoPrestacion,
    codFonasa: state.global.filtros_CAT.codFonasa,
    codPrestacion: state.global.filtros_CAT.codPrestacion,
    tipoAtencion: state.filtroBusqueda.filtros.tipoAtencion,
  },
  datosUsuario: state.global.datosUsuario,
  ENV: state.global.ENV,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(FiltroBusqueda);


// export default FiltroBusqueda;

